import { type FC } from 'react';
import { useIntl, type MessageDescriptor } from 'dibs-react-intl';
import { MultiSelect } from 'dibs-elements/exports/MultiSelect.tsx';
import { Checkbox } from 'dibs-elements/exports/Checkbox.tsx';

type Props = {
    values: string[];
    onChange: (selectedValues?: string[]) => void;
    placeholder: string;
    dataTn: string;
    name: string;
    options: Array<{ value: string | null; label: MessageDescriptor }>;
};

export const NftMarketMultiSelectFilter: FC<Props> = ({
    values,
    onChange,
    options,
    placeholder,
    dataTn,
    name,
}) => {
    const { formatMessage, locale } = useIntl();

    return (
        <MultiSelect
            values={values}
            onChange={selected => onChange(selected.map(s => s.value))}
            options={options.map(option => {
                const label = formatMessage(option.label);
                return {
                    label,
                    value: option.value ?? '',
                    customDropdownDisplay: (
                        <Checkbox
                            checked={values.includes(option.value ?? '')}
                            dataTn={`${dataTn}-option-${label}`}
                            name={`${dataTn}-option-${label}`}
                            onChange={() => {}}
                            label={label}
                            value={option.value ?? ''}
                        />
                    ),
                };
            })}
            size="medium"
            name={name}
            dataTn={dataTn}
            placeholder={placeholder}
            locale={locale}
            dropdownDetachedMode
            clearable={false}
            noResultsPrompt={null}
            showSearchTags={false}
            showCountBadge={false}
            deselectable
        />
    );
};
